export const transformShopRemains = (remains, lotsInStock) => {
   if (lotsInStock) return "В наличии (более 10 шт.)";
   if (remains < 1) return "Нет в наличии";
   if (remains > 0) return `В наличии (${remains} шт.)`;
};

//  - количество карт в магазине. если remains < 1, тогда отображается текст "Нет в наличии"
//, если remains > 0 && remains < 11, тогда отображается текст "В наличии ($remains шт.)",
// если remains > 10, тогда отображается текст "В наличии (более 10 шт.)"